var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000118387529414774492600000016177853013998028970_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 12,
    height: 12
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018917883970223762920000008815103038554271926_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Black_sort-_arrow",
    style: {
      clipPath: "url(#SVGID_00000018917883970223762920000008815103038554271926_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35982",
    transform: "translate(-17012.771 -12926.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40391",
    d: "M17015.3,12931v6h1.5v-6h2.3l-3-3l-3,3H17015.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40392",
    d: "M17020.8,12934v-6h1.5v6h2.3l-3,3l-3-3H17020.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnArrowBlack);
export default __webpack_public_path__ + "static/media/ColumnArrowBlack.30a5d7ddfcf0da0b0cecc81a4c2a8198.svg";
export { ForwardRef as ReactComponent };